import {loadKidActivities} from '../../services/api/kidactivities';
import {getCurrentLocale} from '../../utils/i18n';

export const LOAD_ACTIVITIES_START = 'LOAD_ACTIVITIES_START';
export const LOAD_ACTIVITIES_ERROR = 'LOAD_ACTIVITIES_ERROR';
export const LOAD_ACTIVITIES_COMPLETE = 'LOAD_ACTIVITIES_COMPLETE';

export const loadActivities = () => async (dispatch, getState) => {
    dispatch({type: LOAD_ACTIVITIES_START});

    try {
        let locale = getCurrentLocale();
        let activities = await loadKidActivities(
            locale === 'por' ? 'por' : 'spa',
        );
        dispatch({type: LOAD_ACTIVITIES_COMPLETE, activities});
    } catch (error) {
        dispatch({type: LOAD_ACTIVITIES_ERROR, error});
    }
};
